import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionSubOptionDisplaySettings } from "./settings/display-settings";
import { QuestionOptionSubOptionSettings } from "./settings/root";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	subOption: StandardOptionCategoriesAndManagerStore["subOption"];
};

export const QuestionOptionSubOption = ({ subOption }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={subOption}>
				<QuestionOptionSubOptionSettings />
			</FeatureIslandMainWithCategoryWrapper>

			<QuestionOptionSubOptionDisplaySettings subOption={subOption} />
		</>
	);
};

QuestionOptionSubOption.displayName = "QuestionOptionSubOption";
